import { Message } from 'semantic-ui-react';
import { MODEL_DIFF_DISPLAY_MODE, REPORTS_DIFF_AVAILABILITY } from './constants';
import { hasTableDiffs } from './diffPredicates';
import type { BranchComparison } from './types';
import ComparisonTable from './components/comparisonTable';
import './styles.css';

type BranchComparisonDetailsProps = {
    comparison: BranchComparison;
    summarized: boolean;
    coreDataDiffOnly?: boolean;
    companyId?: string;
};

function BranchComparisonDetails({
    comparison,
    summarized,
    coreDataDiffOnly,
    companyId,
}: BranchComparisonDetailsProps) {
    const { tableDiff, modelDisplayMode, reportsAvailability } = comparison;
    const noDifferences =
        modelDisplayMode === MODEL_DIFF_DISPLAY_MODE.DETAILED &&
        (reportsAvailability === REPORTS_DIFF_AVAILABILITY.AVAILABLE ||
            reportsAvailability === REPORTS_DIFF_AVAILABILITY.REPORTS_CHANGES_PREVIEW) &&
        !hasTableDiffs(tableDiff);

    if (noDifferences) {
        return <Message success>No differences found.</Message>;
    }

    return (
        <div className="branch-comparison-details">
            <ComparisonTable
                comparison={comparison}
                summarized={summarized}
                coreDataDiffOnly={coreDataDiffOnly}
                companyId={companyId}
            />
        </div>
    );
}

export default BranchComparisonDetails;
